var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_5805_15798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.7847 22.7949H9.13281V25.1915H41.7847V22.7949Z",
    fill: "#1C5080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.7847 4.38867H9.13281V22.7953H41.7847V4.38867Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.9008 5.78516H11.0547V21.2137H39.9008V5.78516Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.4823 30.2991H20.5222C20.1689 30.2991 19.8828 29.9928 19.8828 29.6144C19.8828 29.236 20.1689 28.9297 20.5222 28.9297H29.4823C29.8357 28.9297 30.1217 29.236 30.1217 29.6144C30.1217 29.9928 29.8357 30.2991 29.4823 30.2991Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.3307 0H4.66942C3.54205 0 2.625 0.982048 2.625 2.18934V29.3443H47.3751V2.18934C47.3751 0.982048 46.4581 0 45.3307 0ZM45.1624 27.7316H4.82927V1.88301H45.1624V27.7316Z",
    fill: "#1C5080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.6275 31.9841H2.37254C1.06848 31.9841 0 30.8398 0 29.4434V30.2002C0 31.5967 1.06848 32.7409 2.37254 32.7409H18.7279C18.7279 32.7499 18.7279 32.7499 18.7279 32.7589V33.0652C18.7279 33.4436 19.014 33.75 19.3673 33.75H30.6327C30.986 33.75 31.2721 33.4436 31.2721 33.0652V32.7589C31.2721 32.7499 31.2721 32.7499 31.2721 32.7409H47.6275C48.9315 32.7409 50 31.5967 50 30.2002V29.4434C50 30.8398 48.9315 31.9841 47.6275 31.9841Z",
    fill: "#1F8ACB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.262 14.314C25.3549 14.5471 25.7036 14.8268 26.122 14.99C27.6328 15.5494 28.2837 15.5028 28.7486 16.9014C28.0977 17.6007 27.3074 18.1602 26.4009 18.5098H21.3802C20.5667 18.1835 19.8229 17.6706 19.1953 17.0646C19.2418 14.6403 21.9148 16.0389 22.5424 14.314C22.6587 13.9876 22.6587 13.4748 22.5889 13.1484L23.8906 13.1717L25.1922 13.1484C25.1225 13.4748 25.1225 13.9876 25.262 14.314Z",
    fill: "#F0C17D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.262 14.314C25.3317 14.5004 25.5642 14.7335 25.8896 14.8734C27.4469 15.5494 28.5859 15.5261 28.7486 16.9014C28.0978 17.6007 27.3075 18.1602 26.401 18.5098H23.8906V13.1717H23.9139L25.2155 13.1484C25.1226 13.4748 25.1226 13.9876 25.262 14.314Z",
    fill: "#E0AF6A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3281 14.5469L23.8855 14.71L25.4893 14.5469L25.3266 19.4887H22.4908L22.3281 14.5469Z",
    fill: "#A0E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9124 13.9181C23.6102 13.9181 23.494 13.9181 23.3313 13.8482C23.1918 13.7783 23.1221 13.6384 22.9362 13.4519C22.7735 13.2887 22.4713 13.1256 22.4016 12.9624C22.3086 12.7526 22.3318 12.5195 22.2853 12.2165C22.1226 12.3097 21.9599 11.8668 21.9367 11.7036C21.8902 11.4939 21.7275 11.1209 21.681 10.8878C21.6577 10.7479 21.681 10.6314 21.7275 10.6081C21.8205 10.5381 21.9367 10.5848 22.0994 10.7945C22.0994 10.4915 22.0761 10.2351 22.1226 10.002C22.3318 8.76655 25.3303 8.09055 25.6557 10.002C25.7022 10.2351 25.7022 10.4915 25.6789 10.7945C25.8417 10.5848 25.9346 10.5381 26.0508 10.6081C26.0973 10.6547 26.1206 10.7479 26.0973 10.8878C26.0508 11.1209 25.8881 11.4939 25.8417 11.7036C25.8184 11.8435 25.6557 12.2864 25.493 12.2165C25.4697 12.5195 25.4697 12.7526 25.4 12.9624C25.3303 13.1489 25.0281 13.3121 24.8654 13.4752C24.6795 13.6617 24.6097 13.8016 24.4703 13.8715C24.3076 13.9181 24.1681 13.9181 23.9124 13.9181Z",
    fill: "#FFDBA7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9139 13.9173H23.8906V8.81237C24.6809 8.74244 25.4945 9.04547 25.6572 9.97788C25.7036 10.211 25.7036 10.4674 25.6804 10.7704C25.8431 10.5606 25.9361 10.514 26.0523 10.584C26.0988 10.6306 26.122 10.7238 26.0988 10.8637C26.0523 11.0968 25.8896 11.4697 25.8431 11.6795C25.8199 11.8194 25.6572 12.2623 25.4945 12.1924C25.4712 12.4954 25.4712 12.7285 25.4015 12.9383C25.3317 13.1248 25.0296 13.2879 24.8669 13.4511C24.6809 13.6376 24.6112 13.7775 24.4717 13.8474C24.309 13.9173 24.1696 13.9173 23.9139 13.9173Z",
    fill: "#F0C17D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.161 13.9883C25.2075 14.268 25.2773 14.3846 25.4632 14.5244L24.6729 15.8531L23.8594 14.7109C24.2778 14.4778 25.0216 14.1981 25.161 13.9883Z",
    fill: "#DBFBF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6069 13.9883C22.5604 14.268 22.4906 14.3846 22.3047 14.5244L23.095 15.8531L23.9318 14.6876C23.4901 14.4778 22.7463 14.1981 22.6069 13.9883Z",
    fill: "#DBFBF6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3296 14.5234C21.516 15.2461 19.889 14.8964 19.0987 16.0619C18.657 16.6913 18.7732 17.9734 18.75 19.4885H23.4453C23.0966 18.2065 22.6317 15.4092 22.3296 14.5234Z",
    fill: "#134861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9332 14.7559L24.3284 15.3619V15.5018L23.9797 15.8514L24.3516 16.4575L24.2354 19.4879H23.5613L23.4219 16.4575L23.7938 15.8514L23.4451 15.5018V15.3619L23.8403 14.7559H23.9332Z",
    fill: "#266590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9371 14.7559L24.3323 15.3619V15.5018L23.9836 15.8514L24.3555 16.4575L24.2393 19.4879H23.8906V14.7559H23.9371Z",
    fill: "#134861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.329 14.5234C22.1663 14.6633 21.8408 14.8265 21.5387 14.943L21.4922 16.6447L22.236 16.5747L21.8176 17.1342L22.4684 19.4885H23.4447C23.096 18.2065 22.6311 15.4092 22.329 14.5234Z",
    fill: "#266590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5356 9.67534C22.2799 9.97837 22.2102 11.1672 22.2334 11.5868C21.815 10.025 21.5826 8.90609 22.5124 8.20679C23.721 7.29768 25.0924 7.85713 25.3249 8.2301C26.2314 8.71961 25.906 10.1182 25.6503 11.3537C25.6503 10.8875 25.4178 9.74527 25.2319 9.25575C24.5346 8.83616 23.1864 10.1182 22.5356 9.67534Z",
    fill: "#703100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8906 7.71611C24.6112 7.6928 25.1923 7.99583 25.3317 8.22894C26.2383 8.71845 25.9128 10.1171 25.6572 11.3525C25.6572 10.8863 25.4247 9.74411 25.2388 9.25459C24.8901 9.0448 24.402 9.25459 23.8906 9.46438V7.71611Z",
    fill: "#4F2200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4438 14.5234C26.2574 15.2461 27.8844 14.8964 28.6747 16.0619C29.1164 16.6913 28.9769 17.9734 29.0234 19.4885H24.3281C24.6768 18.2065 25.1417 15.4092 25.4438 14.5234Z",
    fill: "#0F303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4438 14.5234C25.5368 14.6167 26.2341 14.943 26.2341 14.943L26.2806 16.6447L25.5368 16.5747L25.9552 17.1342L25.3509 19.4885H24.3281C24.6768 18.2065 25.1417 15.4092 25.4438 14.5234Z",
    fill: "#134861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3538 15.6668L27.8656 18.0911L27.6797 18.6039L28.9581 18.837L29.1441 17.9979L29.4695 16.5759C29.7716 16.3661 29.8646 15.9932 30.1203 15.6901C30.3295 15.457 30.5154 15.3405 30.5852 15.0841C30.6084 14.9442 30.6084 14.781 30.469 14.7111C30.5852 14.6412 30.5619 14.5246 30.5387 14.4314C30.5154 14.3381 30.4922 14.2449 30.3527 14.2682C30.4457 14.1983 30.4457 14.1516 30.4457 14.0584C30.4225 13.9885 30.376 13.8719 30.3062 13.8253C30.2598 13.802 30.19 13.802 30.1203 13.802L30.0971 13.7088C30.19 13.6155 30.376 13.5456 30.3992 13.429C30.4457 13.2892 30.3295 12.9628 30.0041 13.0794L29.3997 13.3125L28.6327 13.4756C28.4932 13.7088 28.4002 13.9185 28.2375 14.175C28.0748 14.4081 28.2143 14.5945 28.2143 14.8976C28.2608 15.2239 28.2608 15.5036 28.3538 15.6668Z",
    fill: "#FFDBA7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1871 15.5036C30.4428 15.2939 30.5125 15.3405 30.5822 15.0841C30.6055 14.9442 30.6055 14.781 30.466 14.7111C30.5822 14.6412 30.559 14.5246 30.5357 14.4314C30.5125 14.3381 30.4892 14.2449 30.3498 14.2682C30.4428 14.1983 30.4428 14.1516 30.4428 14.0584C30.4195 13.9885 30.373 13.8719 30.3033 13.8253C30.2568 13.802 30.1871 13.802 30.1173 13.802L30.0941 13.7088C30.1871 13.6155 30.373 13.5456 30.3963 13.429C30.4428 13.2892 30.3265 12.9628 30.0011 13.0794L29.3968 13.3125L28.9784 13.4057C28.3973 14.105 28.8389 13.9652 28.8622 14.6412C28.8854 15.2472 28.7227 15.6901 29.2573 15.6901C29.699 15.6901 29.9546 15.7134 30.1871 15.5036Z",
    fill: "#EEBE69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6094 19.4895L27.7953 16.4824L29.7246 16.8321L29.6084 19.4895H27.6094Z",
    fill: "#134861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2789 10.166C31.3021 11.5413 31.0465 13.7558 29.4659 13.7558C27.9085 13.7791 27.6064 11.5413 27.6528 10.166H29.4659H31.2789Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6779 10.0488H31.2575C31.3737 10.0488 31.4667 10.1421 31.4667 10.2586C31.4667 10.3752 31.3737 10.4684 31.2575 10.4684H27.6779C27.5617 10.4684 27.4688 10.3752 27.4688 10.2586C27.4688 10.1421 27.5617 10.0488 27.6779 10.0488Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M29.9069 13.4512H29.0469V15.3393H29.9069V13.4512Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9361 15.248H31.0043C31.0973 15.248 31.167 15.318 31.167 15.4112V17.0429C31.167 17.1362 31.0973 17.2061 31.0043 17.2061H27.9361C27.8432 17.2061 27.7734 17.1362 27.7734 17.0429V15.4112C27.7734 15.318 27.8432 15.248 27.9361 15.248Z",
    fill: "#14BAC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M31.2825 16.9023H27.6797V17.2753H31.2825V16.9023Z",
    fill: "#D43726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M30.4216 15.5957H28.5156V16.6214H30.4216V15.5957Z",
    fill: "#D43726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2818 10.166C31.305 11.5413 31.0493 13.7558 29.4688 13.7558V10.166H31.2818Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4688 10.0488H31.2585C31.3748 10.0488 31.4677 10.1421 31.4677 10.2586C31.4677 10.3752 31.3748 10.4684 31.2585 10.4684H29.4688V10.0488Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M29.8871 13.4512H29.4688V15.3393H29.8871V13.4512Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4688 15.248H31.0261C31.0958 15.248 31.1656 15.318 31.1656 15.4112V17.0429C31.1656 17.1362 31.0958 17.2061 31.0261 17.2061H29.4688V16.6933L29.8174 16.1805L29.4688 15.6676V15.248Z",
    fill: "#0EA8B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M31.2585 16.9023H29.4688V17.2753H31.2585V16.9023Z",
    fill: "#BD3222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M30.4218 15.5957H29.4688V16.6214H30.4218V15.5957Z",
    fill: "#BD3222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3071 11.1451C31.2373 11.0052 31.2606 10.8421 31.3071 10.7022C31.7487 9.86304 32.9342 10.3526 32.6552 11.5647C32.539 12.0542 32.1671 12.4738 31.772 12.7302C31.4001 12.9633 31.1676 12.9633 30.9817 13.1032C30.8422 13.2197 30.8887 13.4062 31.0979 13.3596C31.1676 13.3363 31.2373 13.3829 31.2606 13.4528C31.2838 13.5228 31.2373 13.5927 31.1676 13.616C31.0282 13.6626 30.9119 13.6393 30.8422 13.5927C30.5865 13.4528 30.6098 13.1032 30.819 12.9167C30.9584 12.7768 31.2838 12.7768 31.7022 12.4971C32.0509 12.264 32.3298 11.891 32.3995 11.4948C32.632 10.3059 31.4001 10.3059 31.3071 11.1451Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6323 11.1451C27.7021 11.0052 27.6788 10.8421 27.6323 10.7022C27.1907 9.86304 26.0053 10.3526 26.2842 11.5647C26.4004 12.0542 26.7723 12.4738 27.1675 12.7302C27.5394 12.9633 27.7718 12.9633 27.9577 13.1032C28.0972 13.2197 28.0507 13.4062 27.8415 13.3596C27.7718 13.3363 27.7021 13.3829 27.6788 13.4528C27.6556 13.5228 27.7021 13.5927 27.7718 13.616C27.9113 13.6626 28.0275 13.6393 28.0972 13.5927C28.3529 13.4528 28.3296 13.1032 28.1205 12.9167C27.981 12.7768 27.6556 12.7768 27.2372 12.4971C26.8885 12.264 26.6096 11.891 26.5399 11.4948C26.3074 10.3059 27.5394 10.3059 27.6323 11.1451Z",
    fill: "#FDB813"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5783 15.083C30.6248 14.9664 30.6015 14.78 30.4853 14.71C30.2529 14.8033 29.9972 14.8965 29.7647 14.9664C29.6718 15.0131 29.6253 15.1529 29.7183 15.2462C29.788 15.3161 30.0437 15.2695 30.2296 15.2462C30.4621 15.1995 30.5318 15.1762 30.5783 15.083ZM30.4853 14.6867H30.4388L30.3691 14.7333L29.8577 14.9198C29.695 14.9897 29.4626 15.1063 29.3464 15.0597C29.2766 15.0364 29.2301 14.9897 29.2301 14.8732C29.2301 14.78 29.2534 14.71 29.3464 14.6867C29.7183 14.5702 30.0669 14.4303 30.4156 14.2671C30.5085 14.2671 30.5318 14.3604 30.555 14.4303C30.555 14.5235 30.6015 14.6401 30.4853 14.6867ZM30.3691 14.2671C30.0204 14.407 29.695 14.5469 29.2999 14.6867C29.0907 14.7333 29.0209 14.4536 29.1836 14.3137C29.2766 14.2205 29.5788 14.0806 29.8345 13.9874C29.9739 13.9175 30.0902 13.8709 30.1831 13.8475C30.2296 13.8475 30.2761 13.8475 30.2994 13.8709C30.3691 13.8942 30.4156 14.0107 30.4388 14.104C30.4621 14.1506 30.4388 14.1972 30.3691 14.2671ZM30.1366 13.7077C30.2296 13.6378 30.3691 13.5678 30.3923 13.4746C30.4388 13.3347 30.2994 13.0317 30.1366 13.1249C30.0204 13.1949 29.881 13.2648 29.7183 13.358C29.5091 13.4746 29.2999 13.6144 29.3696 13.8009C29.3928 13.8942 29.4858 13.9874 29.6253 13.9175C29.8577 13.8242 29.9739 13.7776 30.1366 13.7077Z",
    fill: "#FFDBA7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6537 13.4746C28.491 13.7077 28.4213 13.9175 28.2586 14.1739C28.0959 14.407 28.2353 14.5935 28.2353 14.8965C28.2353 14.9665 28.2353 15.0131 28.2586 15.083C28.3051 15.0364 28.3515 15.0131 28.3748 14.9665C28.677 14.6867 28.8397 14.477 28.7932 14.0807C29.0024 14.2205 29.444 14.2438 29.537 14.0807C29.63 13.9175 29.3743 13.8243 29.258 13.7543C29.0489 13.6378 28.7932 13.5212 28.6537 13.4746Z",
    fill: "#FFDBA7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5805_15798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 33.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame3.866ed5314627e8a3633f9500a2e80b88.svg";
export { ForwardRef as ReactComponent };